import { sendCreateQuizEvent } from '../index';
import { createQuizEventMetadata } from './CreateQuizEventAdapter.metadata';
import { EventAdapter } from './EventAdapter';

export class CreateQuizEventAdapter extends EventAdapter {
  static metadata = createQuizEventMetadata;

  protected amplitudeEventFunction = sendCreateQuizEvent;
  protected intercomEventKey = 'create-quiz';

  constructor(
    settings: {
      creation_method:
        | 'app'
        | 'excel'
        | 'code'
        | 'quiz_shop'
        | 'link'
        | 'merge'
        | 'copy'
        | 'from_workspace'
        | 'to_workspace'
        | 'create_from_ai'
        | 'create_from_ai_import';
      source_soc_number?: string;
      source_workspace_id?: string;
      destination_workspace_id?: string;
      number_of_quizzes?: number;
    } = {
      creation_method: null,
      source_soc_number: null,
      source_workspace_id: null,
      destination_workspace_id: null,
      number_of_quizzes: 0,
    }
  ) {
    super();

    try {
      this.eventData = settings;
    } catch (err) {
      console.error('Error parsing analytics data', err);
    }
  }
}
